var styles = {"scrollable":"VDS__MON__scrollable-module__p2kV-"};

export { styles as default };
